export default {
  accesibility: 'Accesibilidad',
  add: 'Añadir',
  add_api_ckan: 'API KCAN disponible',
  add_department: 'Departamento',
  add_font: 'Fuente',
  add_geo: 'Geolocalización',
  add_gerence: 'Gerencia',
  add_historic: 'Información histórica',
  add_long_available: 'Formato Long disponible',
  add_more_info: 'Más información',
  add_publication_date: 'Fecha de publicación',
  add_publication_freq: 'Frecuencia de publicación',
  freq_peticio_negoci: 'Según disponibilidad/necesidad',
  add_recent_views: 'Visitas Recientes (últimas 2 semanas)',
  add_title: 'Título',
  add_token: 'Token requerido',
  add_total_views: 'Visitas totales',
  additional: 'Contenido adicional',
  additional_info: 'Información adicional',
  complement_info: 'Descripción complementaria',
  all_dates: 'Todas las fechas disponibles',
  all_details: 'Todos los detalles',
  all_ditricts: 'Todos los distritos',
  all_sources: 'Todos los tipos',
  all_subthemes: 'Todos los subtemas',
  all_themes: 'Todos los temas',
  alphabetical_asc: 'Alfabético A->Z',
  alphabetical_des: 'Alfabético Z->A',
  APPS: 'App',
  back: 'Volver',
  bcn_search_placeholder: 'Buscar en barcelona.cat…',
  btn_apply: 'Aplica',
  btn_clean: 'Limpia',
  camps_definition_title: 'Definición de los campos',
  cancel: 'Cancelar',
  check_results_apl: 'Consultar Resultados en Aplicativo',
  check_results_app: 'Consultar Resultados en la App',
  edit_table_title: 'Editar tabla',
  contact: 'Contacto',
  copy_link: 'Copiar el link',
  cover_title: 'Barcelona Datos',
  data_api: 'Data API',
  date_latest: 'Fecha más antigua',
  date_newest: 'Fecha más reciente',
  dates_from: 'Datos de ',
  det_downloads: 'Descargas totales por ID',
  det_downloads_abs: 'Descargas totales',
  det_format: 'Formato',
  det_last_update: 'Última modificación',
  det_map_view: 'Visualiza mapa',
  det_open_freq: 'Grado de obertura',
  det_publish_date: 'Fecha de publicación',
  det_req_token: 'Token requerido',
  detail: 'Detalle',
  district: 'Distritos de Barcelona',
  DOCS: 'Documento',
  docs_lab: 'Documentos',
  download: 'Descargar',
  download_links: 'Links de descarga',
  download_pdf: 'Descargar PDF',
  drag_dimensions: 'Añadir dimensión',
  enq_afi: 'Afijación',
  enq_companies: 'Empresas designadas',
  enq_contract_conditions: 'Condiciones de contrato',
  enq_date_campo: 'Fecha de realización del trabajo de campo',
  enq_error_sample: 'Error de muestreo',
  enq_methodology: 'Metodología',
  enq_num_register: 'Número de registro',
  enq_pond: 'Ponderación',
  enq_presu: 'Presupuesto (euros)',
  enq_promotor: 'Organismo promotor',
  enq_sample_procedure: 'Procedimiento de muestreo',
  enq_size_mue: 'Tamaño de la muestra',
  enq_tipology: 'Tipología',
  enq_universe: 'Universo',
  enq_validation_date: 'Fecha de validación',
  enq_date_from: 'Fecha de inicio',
  enq_date_to: 'Fecha de fin',
  doc_auth: 'Autor',
  doc_subj: 'Materia',
  doc_geo: 'Cobertura geográfica',
  doc_publish: 'Publicado por',
  doc_ext: 'Extensión',
  doc_note: 'Nota',
  doc_terms_use: 'Condiciones de uso',
  doc_related: 'Documento relacionado',
  doc_colections: 'Aparece en las colecciones',
  show_pdf: 'Ver PDF',
  show_txt: 'Ver TXT',
  SURVEY: 'Encuesta',
  error_response: 'Error de respuesta en la petición',
  error_server_response: 'Error de búsqueda en la petición',
  STATISTICS: 'Tabla estadística',
  file_chart: 'Gráfico',
  file_details: 'Detalles archivo',
  file_details_title: 'Detalles del archivo',
  file_map: 'Mapa',
  file_table: 'Tabla',
  filter_by: 'Filtrar por',
  lang_ca: 'Català',
  lang_en: 'English',
  lang_es: 'Castellano',
  last_3_months: 'Últimos 3 meses',
  last_informed_date: 'Última fecha informada ',
  last_month: 'Último mes',
  last_year: 'Último año',
  legal_adv: 'Aviso legal',
  license: 'Licencia',
  loading: 'Cargando...',
  manual_range: 'Rango manual',
  MAPS: 'Mapa',
  MICRODATA: 'Microdato',
  no_results_search: 'No hemos encontrado resultados para tu búsqueda',
  no_results_tip:
    'Te recomendamos aplicar otros filtros de búsqueda o cambiar la palabra introducida',
  relevance: 'Relevancia',
  results_for: 'resultados por ',
  rows_of: ' filas de ',
  search_placeholder: 'Buscar por palabra...',
  share: 'Compartir',
  sort_by: 'Ordena por:',
  subtheme: 'Subtema',
  table_columns: 'Columnas',
  table_filters: 'Otras dimensiones',
  table_rows: 'Filas',
  table_reset: 'Volver al original',
  table_ord_asc: 'Orden ascendente',
  table_ord_desc: 'Orden descendente',
  table_select_range: 'Seleccionar rango:',
  tooltip_edit_table: 'Editar tabla',
  tooltip_edit_chart: 'Editar gráfico',
  tooltip_edit_map: 'Editar mapa',
  tooltip_two_dim: 'Máximo $n dimensiones',
  theme: 'Tema',
  type: 'Tipo',
  download_file: 'Descargar archivo',
  type_content: 'Tipo de contenido',
  update_date: 'Fecha de actualización',
  use_identifier: 'Por favor, utiliza este identificador para citas o enlazar este ítem: ',
  views_last_year: ' visualizaciones',
  welcome_to_portal: 'O selecciona el tema',
  line_apearence: 'Apariencia de la línea',
  line_values: 'Mostrar valor de los puntos',
  line_labels: 'Mostrar etiquetas de línea',
  chart_legend_title: 'Leyenda',
  chart_horizontal: 'Horizontal',
  chart_vertical: 'Vertical',
  chart_line_round: 'Redondeada',
  chart_line_rect: 'Recta',
  chart_categorical: 'Categórica',
  chart_unicolor: 'Unicolor',
  chart_orientation: 'Orientación',
  chart_color: 'Color',
  chart_x_axis: 'Orientación etiqueta Eje X',
  chart_y_axis: 'Orientación etiqueta Eje Y',
  chart_labels: 'Mostrar etiquetas de barra',
  chart_values: 'Mostrar valores de barras',
  chart_heat_values: 'Mostrar valores',
  chart_legend: 'Mostrar leyenda',
  chart_config: 'Configuración',
  data_config: 'Data',
  table_chart: 'Dimensión visualizada',
  calculating: 'Recalculando...',
  used_unit: 'Unidad: ',
  bar_chart: 'Gráfico de Barras',
  stacked_bar_chart: 'Gráfico de Barras Apiladas',
  grouped_bar_chart: 'Gráfico de Barras Agrupadas',
  line_chart: 'Gráfico de Líneas',
  pie_chart: 'Gráfico de Pastel',
  pyramid_chart: 'Pirámide',
  treemap: 'Quadrificacion',
  radar_chart: 'Radar',
  connected_dotplot: 'Diagrama de puntos',
  heatmap: 'Mapa de calor',
  first_trim: '1r tr',
  second_trim: '2n tr',
  third_trim: '3r tr',
  fourth_trim: '4t tr',
  first_sem: '1r sem',
  second_sem: '2n sem',
  table_compact: 'Compacta',
  table_detail: 'Detallada',
  table_column: 'Columna',
  select_all: 'Seleccionar todas',
  of: ' de ',
  num_cols: ' columnas',
  el_labels: 'Ver nombre de los elementos',
  value_in_labels: 'Mostrar valor en las etiquetas',
  configure_your_table: 'Error de configuración en los datos. Revisa las dimensiones.',
  no_data_for_these_filters: 'No hay datos para estos filtros.',
  too_much_data:
    'No se puede mostrar el gráfico (max 500 celdas). Cambie la seleccion de filtros para ver este gráfico.',
  bcn_data: 'Barcelona al día',
  show_less: 'Ver menos',
  show_more: 'Ver más',
  unselect_all: 'Deseleccionar todas',
  all_op: 'Todos',
  no_op: 'Ninguno',
  selected: ' seleccionados',
  map_prev: 'Link al aplicativo de mapa',
  color_op: 'Paleta de colores',
  colors_by_value: 'Colores según valor',
  colors_by_category: 'Colores según categoría',
  transparency: 'Transparencia',
  steps: 'Pasos',
  head_us: 'Quiénes somos',
  head_help: 'Ayuda',
  week: 'Semana',
  meta_id: 'Enlace de la aplicación',
  DATASTORIES: 'Data Stories',
  datastory_info: 'Consultar Informe Data Story',
  service_unsupported: 'Servicio no soportado',
  map_step_linear: 'Lineal',
  map_step_rounded: 'Valores redondeados',
  map_step_quantile: 'Cuantiles',
  map_step_breaks: 'Pausas naturales',
  show_points: 'Mostrar puntos',
  meta_filters: 'Filtros -> ',
  meta_filters_type: 'Tipos Filtro -> ',
  calendar: 'Calendario',
  no_map_preview: 'Previsualitzación del mapa no disponible',
  color_flip: 'Cambiar ordren de colores',
  datastory_title: 'Data Stories',
  dtst_interactiveapps: 'Aplicaciones interactivas',
  dtst_reports: 'Informes',
  dtst_pdfdocuments: 'Documentos PDF',
  dtst_observatory: 'Observatorios',
  datastory_desc_prev: 'Información de análisis por temas en diversos formatos de consulta',
  news_title: 'Noticias',
  news_desc: 'Mantente al día de lo que pasa en Barcelona',
  calendar_title: 'Agenda',
  calendar_desc: 'Entérate cuando publicamos temas de tu interés',
  new: 'Nuevo',
  update: 'Actualización',
  retard: 'Cambio de fecha',
  add_to_calendar: 'Añadir al calendario',
  notice_prev: 'Noticia anterior',
  notice_next: 'Noticia siguiente',
  see_id: 'Ver el indicador',
  datastory_desc:
    'Los Data Stories ofrecen una visión analítica sobre distintos aspectos de la ciudad. Se ofrecen en distintos formatos como aplicaciones interactivas, informes, documentos PDF y observatorios.',
  datastory_desc2: 'Seleccione este enlace si desea acceder a toda la selección de Data Stories ',
  copy: 'Copiar datos',
  more_op: 'Más opciones',
  map_step_custom: 'Salto de mapa personalizado',
  custom_steps: 'Saltos personalizados',
  normalize_axes: 'Normalitzar ejes',
  no_date_selected: 'Ninguna fecha seleccionada',
  no_date_events: 'No hay eventos para la fecha seleccionada',
  geo_not_supported: 'Mapa no disponible',
  page_not_available: 'Esta página no existe, vuelve a la portada.',
  backend_error: 'El recurso no está accesible en openData',
  not_csv: 'csv no encontrado',
  not_cms: 'Contenido del CMS no disponible',
  related_content: 'Contenido relacionado',
  data_and_resources: 'Datos más recientes',
  lat: 'Latitud',
  lng: 'Longitud',
  login: 'Iniciar sesión',
  email: 'Dirección de correo electrónico',
  email_ex: 'nombre@correo.com',
  client_id: 'ClientID',
  ask_client_id: 'Solicitar ClientID',
  client_id_required: 'Es necesario disponer de un ClientId para el uso de esta API',
  how_to_get_client:
    'Para conseguir un ClientId, dentro de tu zona de usuario, en pestaña de datos personales encontrarás un botón para solicitar esta clave única y personal.',
  user_zone: 'Accede a tus ',
  password: 'Contraseña',
  password_ex: 'Introduce tu contraseña',
  password_forgot: '¿Has olvidado la contraseña?',
  session_remember: 'Mantener la sesión iniciada',
  not_member: '¿Todavía no eres miembro?',
  want_register: 'Quiero registrarme',
  register: 'Registrarse',
  required_field: '* Campo obligatorio',
  reg_name: 'Nombre',
  reg_name_ex: 'Introduce tu nombre',
  reg_sur: 'Apellidos',
  reg_sur_ex: 'Introduce tus apellidos',
  reg_email_con: 'Confirmar correo electrónico*',
  reg_lang: 'Lengua',
  reg_sex: 'Sexo',
  sex_M: 'Hombre',
  sex_F: 'Mujer',
  sel_placeholder: 'Selecciona una opción',
  reg_pass_con: 'Verificar contraseña*',
  password_req: 'La contraseña debe tener como mínimo',
  pass_req1: '8 carácteres',
  pass_req2: '1 mayúscula',
  pass_req3: '1 minúscula',
  pass_req4: '1 número',
  terms_and_cond: 'cláusula de privacidad',
  reg_dates_prot:
    'Estoy informado de la política de protección de datos y doy consentimento al tratamiento de mis datos de carácter personal',
  reg_more_inf: 'Puede encontrar la información del tratamiento 0690 en este enlace: ',
  want_login: '¿Ya tienes cuenta? ',
  my_space: 'Mi espacio',
  user_dates: 'Datos del usuario',
  fav_list: 'Lista de favoritos',
  view_lib: 'Biblioteca de vistas',
  comun_pref: 'Preferencias de comunicaciones',
  drop_out: 'Darse de baja',
  last_mod: 'Última modificación ',
  email_low: 'Correo electrónico',
  save: 'Guardar',
  tem_new_cont: '¿Sobre qué temas quieres recibir información cuando agregemos nuevo contenido?',
  temp_freq_news: 'Selecciona la temporalidad y frecuencia de los avisos que deseas recibir:',
  temp_none: 'Ninguna',
  temp_month: 'Mensual',
  temp_week: 'Semanal',
  favs_for: 'favoritos por ',
  update_noti: 'Notificar actualitzaciones',
  saved: 'Guardado',
  agree: 'Aceptar',
  location: 'Territorio',
  all_locations: 'Todos los territorios',
  supramunicipal: 'Supramunicipal',
  municipi: 'Municipio',
  districte: 'Distrito',
  barri: 'Barrio',
  area_estadistica_basica: 'Área Estadística Básica',
  seccio_censal: 'Sección Censal',
  codi_postal: 'Código postal',
  and: 'y',
  dia: 'Diario',
  setmana: 'Semanal',
  mes: 'Mensual',
  trimestre: 'Trimestral',
  any: 'Anual',
  all_filters: 'Todos los temas',
  logout: 'Cerrar sesión',
  activate_title: 'Confima tu email para acabar el registro',
  confirm: 'Confirmar',
  invalid_title: 'Usuario no validado',
  invalid_desc:
    'Tus datos son correctos, pero tu email no ha sido confirmado. Revisa tu bandeja de entrada o haz click en el botón de abajo para volver a enviar otro correo de validación al email registrado.',
  send: 'Volver a enviar',
  forgot_desc:
    'Introduce tu dirección de correo electrónico para enviar un email de recuperación y poder cambiar tu contraseña.',
  registred_user: 'Usuario registrado correctamente',
  validate_desc:
    'Revisa tu bandeja de entrada o haz click en el botón de abajo para volver a enviar otro correo de validación al email registrado.',
  valid_title: 'Tu usuario ya está activo',
  valid_desc: 'Ve a la página de iniciar sesión y empieza a guardar tus datos.',
  password_title: 'Tu contraseña ya se ha actualizado',
  password_desc: 'Ve a la página de iniciar sesión para ver los cambios.',
  change_pw_title: 'Cambia tu contraseña',
  change_pw_desc: 'Rellena los siguientes campos para finalizar el cambio de contraseña',
  new_pw: 'Nueva contraseña',
  conf_new_pw: 'Confirmar nueva contraseña',
  error_login: 'Usuario o contraseña incorrectos',
  delete_user:
    'Introduce tu dirección de correo electrónico y haz click en el botón confirmar para eliminar a tu usuario de la base de datos',
  delete_user_confirm:
    'El usuario se ha eliminado correctamente del sistema y ya no se encuentra registrado.',
  delete_thanks: 'Gracias por utilizar nuestros servicios.',
  drop_out_confirm: '¿Seguro que quieres darte de baja?',
  head_links: 'Webs de interés',
  pref_noti_title: 'Permitir notificaciones de contenido actualizado',
  pref_noti_desc:
    'Cuando las notificaciones están activas, puedes elegir recibir las que son relevantes para ti',
  pref_noti_active: 'Activadas',
  error_token: 'Token invalido o caducado',
  create_newest: 'Fecha de creación más reciente',
  create_latest: 'Fecha de creación más antigua',
  data_error: 'Error en los datos',
  pref_noti_favs_default_title: 'Notificar actualizaciones de los nuevos favoritos',
  pref_noti_favs_default_desc:
    '(Cambiar el estado por defecto de las notificaciones en los nuevos favoritos agregados)',
  email_send: 'Correo electrónico enviado',
  email_desc: 'Comprueba tu bandeja de entrada y revisa los últimos correos recibidos',
  sex_NS: 'No definido',
  no_views_fav:
    'No se han encontrado vistas para los filtros seleccionados, añade nuevos favoritos desde las vistas de indicadores estadísticos',
  no_favs: 'Aún no tienes elementos en la lista de favoritos.',
  no_favs_ex: 'Empieza a añadirlos desde las distintas páginas de indicadores.',
  reg_req: 'Este campo no puede estar vacío.',
  reg_email: 'Este campo no puede estar vacío y debe seguir el formato de correo electrónico.',
  reg_email_conf:
    'Este campo no puede estar vacío y debe coincidir con el otro correo electrónico introducido.',
  reg_pass: 'Este campo no puede estar vacío y debe seguir el formato de contraseña requerido.',
  reg_pass_conf: 'Este campo no puede estar vacío y debe coincidir con la otra contraseña.',
  reg_check: 'Es necesario aceptar las condiciones para completar el registro.',
  api_micro_title: 'Microdatos/Export',
  api_def: 'Definición del método de la API:',
  api_micro_def_res: '/microdata/export',
  api_func: 'Funcionalidad:',
  api_micro_func_res:
    'Obtiene el archivo CSV con los datos de uno de los recursos de un indicador concreto de tipos microdatos a partir del identificador del indicador y del recurso. El usuario del Portal de Datos, seleccionará el elemento, de tipo microdatos, de lo que quiere ver la información de la lista de elementos que se le presentarán en el frontend, lo que seleccionará el archivo a descargar.',
  api_micro_ex: 'Ejemplo:',
  api_res:
    'Se puede ver un ejemplo de resultado de una llamada a este endpoint con los parámetros de este archivo:',
  api_stat_title: 'Estadísticas/Export',
  api_stat_def_res: '/statistic/export',
  api_stat_func_res:
    'Obtiene un archivo en formato CSV o Excel con la tabla de datos del indicador asociado al identificador pasado como parámetro.',
  api_stat_ex_1: 'Ejemplo (Excel):',
  api_stat_ex_2: 'Ejemplo (CSV):',
  api_extra:
    'Para descargar estos archivos desde otra aplicación debe utilizarse esta instrucción:',
  statistics: 'Estadísticas',
  copied: 'Copiado!',
  unique_values: 'Valores únicos',
  valid: 'Válidos',
  missing: 'Faltan',
  most_common: 'Más comun',
  average: 'Media',
  deviation: 'Desviación',
  others: 'Otros',
  count: 'Cuenta',
  single_value: 'Valor único',
  unique_date: 'Única fecha disponible: ',
  microdata_loader:
    'Estamos calculando los detalles de las columnas. Estos seran visibles pasados 30 segundos aproximadamente.',
  home: 'Home',
  stat_content: 'Estadísticas de contenido',
  stat_use: 'Estadísticas de uso',
  profiles_use: 'Perfiles de uso',
  last_week: 'Última semana',
  pbd_content_title_char_1: 'Evolución número de ítems por tipo de archivo',
  pbd_content_title_char_2: 'Distribución por tipo de archivo',
  pbd_content_title_char_3: 'Evolución de los ítems por temáticas',
  pbd_content_title_char_4: 'Distribución por temáticas',
  pbd_use_title_char_1: 'Número de accesos a la web',
  pbd_use_title_char_2: 'Evolución del número de usuarios registrados',
  pbd_use_title_char_3: 'Ítems más consultados',
  pbd_use_title_char_4: 'Ítems más descargados',
  pbd_use_title_char_5: 'Palabras más buscadas',
  pbd_profiles_title_char_1: 'Idioma',
  pbd_profiles_title_char_2: 'Dispositivo',
  pbd_profiles_title_char_3: 'País',
  pbd_profiles_title_char_4: 'Hora',
  all_types: 'Todos los tipos',
  add_range: 'Rango de valores',
  add_filter: 'Filtro por tipo',
  add_search: 'Filtro por palabra',
  users: 'Usuarios',
  interactions: 'Interacciones',
  user_blocked: 'Usuario bloqueado por el administrador',
  MON: 'Lun',
  TUE: 'Mar',
  WED: 'Mie',
  THU: 'Jue',
  FRI: 'Vie',
  SAT: 'Sab',
  SUN: 'Dom',
  quote_and_license: 'Condiciones de uso',
  location_type: 'Tipo de territorio',
  map_base: 'Base',
  map_no_base: 'Sin Base',
  page_429: 'Datos no disponibles temporalmente, vuelve a intentarlo más tarde',
  overwrite: 'Sobrescribir',
  copy_embed: 'Copiar codigo de incrustación',

  meta_description:
    'Integra y difunde datos y análisis de la situación actual y la evolución de Barcelona desde las vertientes demográfica, económica, social, política y de la percepción ciudadana.',
  meta_keywords:
    'Oficina Municipal de Datos, OMD, Departamento de estadística, Difusión de datos, Encuestas, Estudios de opinión, Registro de encuestas, Ayuntamiento de Barcelona, Gabinete Técnico de Programación, estadística, estadísticas, open data, datos abiertos, Barcelona, BCN, Anuario estadístico, población, economía, trabajo, medio urbano, transportes, movilidad, vivienda, sociedad, política, administración municipal, cartografía Barcelona.',
  embed: 'Incrustar',
  dropdown_index: 'Índice desplegable',
  index: 'Índice',
  not_cms_lang: 'Informe no disponible para este idioma',
  register_required: 'Es necesario tener un usuario personal para hacer uso de esta api',
  how_to_register: 'Para tener este usuario sólo necesitas rellenar el siguiente formulario: ',
  if_user: 'Si ya tienes un usuario haz clic en el botón superior para iniciar sesión.',
  client_id_pending: 'Client id solicitado y pendiente de validación',
  login_advantages: 'Descubre las ventajas de estar registrado pulsando ',
  here: 'aquí',
  session_ended: 'Tu sesión ha finalizado, haz click aquí para volver a acceder:',
  tornarPrincipal: 'Volver a la pantalla principal',
  add_dades_alt_valor: 'Datos de alto valor',
}
